<template>
  <div
    v-if="data.kicker"
    :class="[
      'font-bold',
      'tracking-widest',
      'md:text-lg',
      'lg:text-xl',
      'text-lg',
      'uppercase',
      'drop-shadow-xl',
      data.text_color || 'text-white',
    ]"
    :style="{
      color: data.text_custom_color,
      fontSize: `${data.kicker_size || 2}rem`,
    }"
  >
    <div class="text-[50%] leading-normal sm:text-[100%]">
      {{ data.kicker }}
    </div>
  </div>
</template>

<script lang="ts">
import type { SbStageSlide } from '~/cms/storyblok/types/storyblok.d.ts'

export default defineComponent({
  name: 'StageKicker',
  props: {
    data: {
      type: Object as PropType<SbStageSlide>,
      required: true,
    },
  },
})
</script>
